<template>
  <div class="s-layout">
    <Loading v-if="isLoading" loading-message="載入中..." :background-color="'#ffffff'" />

    <div class="s-container">
      <div class="content" :style="colors">
        <div class="custom-elanco-header">
          <span class="custom-elanco-header__text">Hi {{ deepGet(user, 'name') }}</span>
          <a :href="deepGet(event, 'config.header_logo_url', '#')">
            <img
              v-if="deepGet(event, 'config.images.header_logo')"
              :src="deepGet(event, 'config.images.header_logo')"
              class="custom-elanco-header__image ml-3"
            >
          </a>
        </div>


        <div>
          <img v-if="deepGet(event, 'config.images.mgm_kv')" :src="deepGet(event, 'config.images.mgm_kv')" alt="Elanco" class="img-fluid">
        </div>

        <div class="py-3 px-4">
          <div
            class="text-center pt-3 content__success__title"
            v-html="successMessageTitle"
          ></div>
          <div
            class="text-center pb-3 content__success__message"
            v-html="successMessage"
          ></div>

          <template v-if="canInviteFriends">
            <button class="s-btn s-btn-primary s-btn-xs mb-2" type="button" :disabled="isLoading" @click="handleShareButtonIsClicked">
              一鍵分享邀請連結
            </button>
            <button class="s-btn s-btn-outline-primary s-btn-xs mb-2" type="button" :disabled="isLoading" @click="goToMgmIntro">
              揪友賺點 獎勵說明
            </button>
            <button class="s-btn s-btn-outline-primary s-btn-xs mb-2" type="button" :disabled="isLoading" @click="goToPointsProgress">
              開始掃描集點
            </button>
            <button class="s-btn s-btn-outline-primary s-btn-xs" type="button" :disabled="isLoading" @click="goToCouponList">
              查看回饋詳情
            </button>
          </template>
          <template v-else>
            <button class="s-btn s-btn-primary s-btn-xs mb-2" type="button" :disabled="isLoading" @click="goToPointsProgress">
              開始掃描集點
            </button>
            <button class="s-btn s-btn-outline-primary s-btn-xs mb-2" type="button" :disabled="isLoading" @click="goToMgmIntro">
              揪友賺點 獎勵說明
            </button>
            <button class="s-btn s-btn-outline-primary s-btn-xs mb-2" type="button" :disabled="isLoading" @click="goToElancoIntro">
              查看集點活動完整辦法
            </button>
            <button class="s-btn s-btn-outline-primary s-btn-xs" type="button" :disabled="isLoading" @click="goToCouponList">
              查看回饋詳情
            </button>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import deepGet from "lodash/get";
import liff from "@line/liff";
import https from "@/apis/liff/v2/https";
import Loading from "@/components/Page/Liff/Shared/Loading";
// Api
import redeemApi from "@/apis/liff/v2/redeem";

export default {
  components: {
    Loading,
  },
  data() {
    return {
      isLoading: false,
      eventCode: null,
      event: {
        config: {},
      },
      error_message: [],
      isMgmSuccess: false,
      redeemedCount: 0,
      hasRefParam: false,
    };
  },
  computed: {
    ...mapGetters({
      meta: "liffGeneral/meta",
      themeConfig: "liffGeneral/themeConfig",
      liffId: "liffGeneral/liffId",
    }),
    ...mapGetters("liffAuth", ["user"]),
    colors() {
      return {
        "--header_bg_color": this.event.config.header_bg_color,
        "--header_text_color": this.event.config.header_text_color,
        "--submit_bg_color" : this.event.config.submit_bg_color,
        "--submit_text_color": this.event.config.submit_text_color
      }
    },
    successMessageTitle() {
      return deepGet(this.event, 'config.mgm.success_message_title', '');
    },
    successMessage() {
      return deepGet(this.event, 'config.mgm.success_message', '');
    },
    canInviteFriends() {
      return this.redeemedCount > 0;
    },
  },
  async mounted() {
    this.eventCode = this.$route.query.event_code;
    const ref = this.$route.query.ref;
    this.hasRefParam = Boolean(ref);

    if (!this.eventCode) {
      this.$swal({
        text: '網址錯誤，缺少活動代碼',
        confirmButtonText: '確定',
      });
      return;
    }

    await this.fetchEvent();
    await this.fetchInitData();

    if (ref) {
      await this.processMgm(this.eventCode, ref);
    }
  },
  methods: {
    deepGet,
    async fetchInitData() {
      try {
        this.isLoading = true;

        const response = await https.get(`${this.$store.state.liffGeneral.orgCode}/liff/elanco/init2026`, {
          params: {
            event_code: this.eventCode,
          }
        });

        this.redeemedCount = Number(deepGet(response, 'data.data.redeemed_count', 0));
      } catch (error) {
        console.error(error);
        this.redeemedCount = 0;
      } finally {
        this.isLoading = false;
      }
    },
    async fetchEvent() {
      try {
        this.isLoading = true;

        const eventRes = await redeemApi.getRedeemEvent({
          event_code: this.eventCode,
        });

        this.event = eventRes.data.data.event;
        this.error_message = eventRes.data.data.event.config.error_message ?? [];

      } catch (error) {
        console.error(error);
        if (error.response?.status === 400) {
          const errorMessageConfig = this.findMappedError(error.response.data.message);
          this.$swal({
            text: deepGet(errorMessageConfig, 'message', '設定錯誤'),
            confirmButtonText: '確定',
          })
        } else {
          this.$swal({
            text: '活動資訊讀取失敗',
            confirmButtonText: '確定',
          })
        }
      } finally {
        this.isLoading = false;
      }
    },
    findMappedError(code) {
      const errorMessageConfig = this.error_message ?? [];
      return errorMessageConfig.find(item => item.code === code);
    },
    async processMgm(eventCode, ref) {
      try {
        this.isLoading = true;

        const response = await https.post(`${this.$store.state.liffGeneral.orgCode}/liff/elanco/mgm2026`, {
          event_code: eventCode,
          ref: ref,
        });

        this.isMgmSuccess = response.data.message === 'MGM_SUCCESS';

        const mgmMessage = deepGet(this.event, 'config.mgm.message', []).find(message => message.code === response.data.message);

        if (mgmMessage?.message) {
          this.$swal({
            title: mgmMessage.title ?? '',
            html: mgmMessage.message,
            confirmButtonText: '確定',
          });
        }
      } catch (error) {

        const errMessage = deepGet(this.event, 'config.mgm.message', []).find(message => message.code === error.response.data.message);

        if (errMessage?.message) {
          this.$swal({
            title: errMessage.title ?? '',
            html: errMessage.message,
            confirmButtonText: '確定',
          });
        }

      } finally {
        this.isLoading = false;
      }
    },
    goToCouponList() {
      if (!this.liffId) {
        this.$swal({
          text: 'LIFF 設定錯誤，請稍後再試',
          confirmButtonText: '確定',
        });
        return;
      }

      window.location.href = `https://liff.line.me/${this.liffId}/coupon`;
    },
    goToElancoIntro() {
      if (!this.liffId) {
        this.$swal({
          text: 'LIFF 設定錯誤，請稍後再試',
          confirmButtonText: '確定',
        });
        return;
      }

      window.location.href = `https://liff.line.me/${this.liffId}/page/elanco2026_intro`;
    },
    goToMgmIntro() {
      if (!this.liffId) {
        this.$swal({
          text: 'LIFF 設定錯誤，請稍後再試',
          confirmButtonText: '確定',
        });
        return;
      }

      window.location.href = `https://liff.line.me/${this.liffId}/page/elanco2026_mgm`;
    },
    async handleShareButtonIsClicked() {
      try {
        if (!liff.isApiAvailable('shareTargetPicker')) {
          this.$swal({
            text: '此 LINE 帳號尚未開啟 Share Target Picker 功能',
            confirmButtonText: '確定',
          });
          return;
        }

        this.isLoading = true;
        const response = await https.get(`${this.$store.state.liffGeneral.orgCode}/liff/share_picker_elanco`);
        const message = deepGet(response, 'data.data', {});
        await liff.shareTargetPicker([message], { isMultiple: true });
      } catch (error) {
        console.error(error);
        this.$swal({
          text: '發生錯誤，無法進行分享',
          confirmButtonText: '確定',
        });
      } finally {
        this.isLoading = false;
      }
    },
    goToPointsProgress() {
      if (!this.liffId) {
        this.$swal({
          text: 'LIFF 設定錯誤，請稍後再試',
          confirmButtonText: '確定',
        });
        return;
      }

      window.location.href = `https://liff.line.me/${this.liffId}/proj/elanco/2026?event_code=elancotw2026`;
    },
  },
};
</script>

<style lang="scss" scoped>
.s-layout {
  min-height: 100vh;
  background-color: #fff;
}
.custom-elanco-header {
  padding: 16px;
  background-color: var(--header_bg_color);
  color: var(--header_text_color);
  font-size: 1.25rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &__image {
    height: 40px;
  }
}
</style>

<style lang="scss">
@import "../../../../assets/css/liff/main.css";
@import "../../../../assets/css/liff/liff_init_theme_config.css";
@import '../../../../assets/scss/shared/components/_fields.scss';

.s-layout {
  color: var(--liff-primary_text_color);
  background-color: var(--liff-layout_bg_color);
  --s-gray: #979797 !important;
  --s-gray-light: #f0f0f0 !important;
}

.s-container {
  min-height: 100vh;
  position: relative;
  max-width: 768px;
  margin: auto;
}

.s-layout,
.s-layout *,
.s-layout *:before,
.s-layout *:after {
  --s-secondary: #de006f;
  --s-warning: #ed6c00;
  --s-danger: #fe0000;
  --s-gray-darker: #363636;
  --s-gray-dark: #2c2c2e;
  --s-gray: #979797 !important;
  --s-gray-light: #c0c4cc;
  --s-gray-lighter: #f2f2f7;
  --liff-button-color: #93bf65;
  --liff-primary_text_color: #93bf65;
  --s-primary: #93bf65;
}

.content {
  height: 100vh;
  overflow-y: auto;
  margin: 0;
  color: var(--liff-primary_text_color);

  &__success {
    &__title {
      font-size: 24px;
      font-weight: 600;
      color: var(--liff-primary_text_color);
      margin-bottom: 8px;
    }

    &__message {
      color: #008000;
    }
  }
}

.s-btn-primary {
  background-color: var(--liff-button-color) !important;
}

.s-btn-outline-primary {
  border-width: 3px !important;
}
</style>
